"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3481],{

/***/ 63481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CardTitle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87771);
/* harmony import */ var src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34892);
/* harmony import */ var src_utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39334);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(186);
/* harmony import */ var _link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(477);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  background-color: var(--softwhite-color);\n  padding: 10px;\n  .card-title {\n    font-size: 18pt;\n    font-weight: 500;\n    line-height: 1.2;\n    color: var(--text-color);\n    font-family: 'DBHelvethaicaXMed', sans-serif;\n    letter-spacing: 0;\n  }\n  .date-publish {\n    &.--icon {\n      margin-bottom: 2px;\n      margin-right: 4px;\n    }\n  }\n\n  small {\n    /* font-family: 'Nunito Sans', sans-serif !important; */\n    text-transform: lowercase;\n    font-size: 15pt;\n    font-weight: 200;\n    line-height: 1;\n\n    color: #707070;\n  }\n  @media (max-width: 767px) {\n    .card-title,\n    small {\n      padding-left: 25px;\n    }\n    .card-title {\n      &:before {\n        position: absolute;\n        content: '';\n        width: 15px;\n        height: 15px;\n        left: 8px;\n        top: 20px;\n        background: var(--primary-color);\n        border-radius: 0 5px 0 5px;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








function CardTitle(param) {
    var data = param.data, _className = param.className, className = _className === void 0 ? "" : _className, _eventDataLayer = param.eventDataLayer, eventDataLayer = _eventDataLayer === void 0 ? {} : _eventDataLayer, _path = param.path, path = _path === void 0 ? "" : _path, _showPublishDate = param.showPublishDate, showPublishDate = _showPublishDate === void 0 ? false : _showPublishDate, _isSectionLive = param.isSectionLive, isSectionLive = _isSectionLive === void 0 ? false : _isSectionLive, _sectionLive = param.sectionLive, sectionLive = _sectionLive === void 0 ? [] : _sectionLive;
    if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default()(data)) return null;
    var href = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return "".concat((data === null || data === void 0 ? void 0 : data.link) || path);
    }, [
        data,
        path
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CardWrapper, {
        className: "card-title ".concat(className),
        // ! DATALAYER
        onClick: function() {
            return (0,src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_4__/* .sendDataLayerGlobal */ .dE)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, eventDataLayer));
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_link__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            title: data === null || data === void 0 ? void 0 : data.title,
            href: href,
            tabIndex: -1,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                    className: "card-title ".concat(isSectionLive ? "" : "text-ellipsis-2"),
                    children: data === null || data === void 0 ? void 0 : data.title
                }),
                showPublishDate && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("small", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_8__/* .AiOutlineClockCircle */ .cjn, {
                            size: 15,
                            className: "date-publish --icon"
                        }),
                        isSectionLive ? data === null || data === void 0 ? void 0 : data.timeline : (data === null || data === void 0 ? void 0 : data.published_at) && (0,src_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .useDateUpdate */ .WR)(data === null || data === void 0 ? void 0 : data.published_at)
                    ]
                })
            ]
        })
    });
};
var CardWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div(_templateObject());


/***/ }),

/***/ 477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34892);





var Link = function(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, _href = _param.href, href = _href === void 0 ? "" : _href, _title = _param.title, title = _title === void 0 ? "" : _title, _target = _param.target, target = _target === void 0 ? "_self" : _target, _nofollow = _param.nofollow, nofollow = _nofollow === void 0 ? false : _nofollow, eventDataLayer = _param.eventDataLayer, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "href",
        "title",
        "target",
        "nofollow",
        "eventDataLayer",
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: className,
        title: title,
        target: target,
        href: href,
        rel: "noopener noreferrer ".concat(nofollow ? "nofollow" : ""),
        // ยิง datalayer เฉพาะตอนได้รับ eventDataLayer ที่มี type จริง
        // กันเคสการ์ดที่ไม่ได้ส่ง eventDataLayer มา (เดิม <Link> จะยิงก้อนว่างทับของจริง = "คลิกแล้วไม่ได้ค่า")
        onClick: (eventDataLayer === null || eventDataLayer === void 0 ? void 0 : eventDataLayer.type) ? function() {
            return (0,src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_1__/* .sendDataLayerGlobal */ .dE)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, eventDataLayer));
        } : undefined
    }, props), {
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Link);


/***/ })

}]);